import { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons, DeleteConfirmationModal } from "@components";
import { UploadDocumentForm } from "./UploadDocumentForm";

import { UploadFileType } from "@type/HRM/upload-file";
import { OtherAttachedFilesFormDataType } from "@validations/HRM/employee/attachedFiles";

interface AttachedFilePropsType {
  attachedFile: UploadFileType;
  createAttachedFile: (data: UploadFileType) => void;
  removeAttachedFile: (uploadFile: UploadFileType) => void;
  getAttachedFileRequestOngoing: boolean;
  updateAttachedFileRequestOngoing: boolean;
  deleteAttachedFileRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const UploadDocument = ({
  attachedFile,
  createAttachedFile,
  removeAttachedFile,
  getAttachedFileRequestOngoing,
  updateAttachedFileRequestOngoing,
  deleteAttachedFileRequestOngoing,
  isProfileDisabled,
}: AttachedFilePropsType) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);

  const { id, documentName, memorialNo, remarks, date, ...rest } =
    attachedFile || {};

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    closeConfirmationModal();
    removeAttachedFile(attachedFile);
  };

  const methods = useForm<OtherAttachedFilesFormDataType>({
    values: {
      id,
      documentName,
      memorialNo,
      remarks,
      date,
      attachmentDocument: rest,
    } as any,
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<OtherAttachedFilesFormDataType> = (
    data: OtherAttachedFilesFormDataType,
  ) => {
    const { id, documentName, memorialNo, remarks, date, attachmentDocument } =
      data as OtherAttachedFilesFormDataType;

    createAttachedFile({
      ...attachmentDocument,
      id,
      documentName,
      memorialNo,
      remarks,
      date,
    });
  };

  let isSaving =
    getAttachedFileRequestOngoing || updateAttachedFileRequestOngoing;
  let isDeleting =
    getAttachedFileRequestOngoing || deleteAttachedFileRequestOngoing;

  return (
    <>
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}
      <FormProvider {...methods}>
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <UploadDocumentForm isProfileDisabled={isProfileDisabled} />
          {!isProfileDisabled && (
            <ActionButtons
              isSaving={isSaving}
              isDeleting={isDeleting}
              deleteAction={() => setIsConfirmationModalOpen(true)}
            />
          )}
        </form>
      </FormProvider>
    </>
  );
};
